import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { ErrorPage } from "@/components";
import { ErrorPageType, PermissionRoles } from "@/enum";
import { useHasPermissions } from "@/utils/useHasPermissions";

import { CourseDetails } from "../Course/components/CourseDetails";
import CourseInProgressPage from "../Course/pages/CourseInProgressPage";
import { CreateCoursesForm } from "./components/CreateCoursesForm";

import { CoursesOverview } from "./pages/CoursesOverview/CoursesOverview";
import { GenerateCourseForm } from "./components/GenerateCourseForm";
import { UpdateCoursesFormWrapper } from "./components/UpdateCoursesFormWrapper";
import { VideoWizard } from "./pages/VideoWizard/VideoWizard";

export const Courses: FunctionComponent = () => {
	const { hasPermissions } = useHasPermissions();
	const globalAdminOnly = (page: JSX.Element) =>
		hasPermissions([PermissionRoles.GLOBAL_ADMIN]) ? (
			page
		) : (
			<ErrorPage type={ErrorPageType.NotFound} />
		);

	return (
		<Routes>
			<Route element={<CoursesOverview />} path="/" />
			<Route element={<CourseDetails />} path="/:id" />
			<Route element={<CourseInProgressPage />} path="/:id/progress" />
			{/* Authoring is the Global Admin's alone: AI video creation (BCM360-356) and creating,
			    generating and editing scenarios (BCM360-358). The routes stay registered for everyone
			    so "/create" and "/generate" cannot fall through to "/:id" as a scenario id. */}
			<Route element={globalAdminOnly(<GenerateCourseForm />)} path="/generate" />
			<Route element={globalAdminOnly(<CreateCoursesForm />)} path="/create" />
			<Route element={globalAdminOnly(<UpdateCoursesFormWrapper />)} path="/edit/:id" />
			<Route element={globalAdminOnly(<VideoWizard />)} path="/edit/:id/intro-video" />
		</Routes>
	);
};
